import type { AgentSessionMessageDTO } from '@/services/roros/agent-sessions.service';
import type { ChatMessage } from './components/AgentChatPageParts';

type MapAgentSessionMessagesOptions = {
  includeSystem?: boolean;
};

export function mapAgentSessionMessages(
  messages: AgentSessionMessageDTO[] | null | undefined,
  options: MapAgentSessionMessagesOptions = {},
): ChatMessage[] {
  return (messages ?? [])
    .filter((message) => options.includeSystem || message.role !== 'system')
    .map((message) => ({
      id: message.id,
      role: message.role as ChatMessage['role'],
      content: message.content,
      toolName: message.toolName,
      toolInput: message.toolInput ?? null,
      toolResult: message.toolResult ?? null,
      invokedSkillId: message.invokedSkillId ?? null,
    }));
}
